import type { TextFieldProps } from "@mui/material";
import { TextField } from "@mui/material";
import type { FC } from "react";
import { useEffect, useRef } from "react";

export const TextFieldWithAutoFocus: FC<TextFieldProps> = (params) => {
  const ref = useRef<HTMLInputElement>(null);
  useEffect(() => {
    setTimeout(() => {
      ref.current?.focus();
    }, 100);
  }, []);

  return <TextField {...params} inputRef={ref} />;
};
